import type { CSSProperties } from "react";
import {
  getListColor,
  ListColorKey,
  AREA_COLORS,
  resolvePairedColorKeys,
} from "@/lib/listColors";

export type DisplayThemeInput = {
  primaryColor?: string | null;
  secondaryColor?: string | null;
  fallbackPrimary?: string | null;
  fallbackSecondary?: string | null;
  iconKey?: string | null;
};

export type DisplayTheme = {
  primaryKey: ListColorKey;
  secondaryKey: ListColorKey;
  primary: (typeof AREA_COLORS)[ListColorKey];
  secondary: (typeof AREA_COLORS)[ListColorKey];
  iconKey: string | null;
};

export function resolveDisplayTheme(input: DisplayThemeInput): DisplayTheme {
  const resolved = resolvePairedColorKeys(input);

  return {
    primaryKey: resolved.primary,
    secondaryKey: resolved.secondary,
    primary: getListColor(resolved.primary),
    secondary: getListColor(resolved.secondary),
    iconKey: input.iconKey ?? null,
  };
}

export function getPrimaryActionStyle(theme: DisplayTheme): CSSProperties {
  return {
    background: theme.primary.base,
    color: theme.secondary.soft,
  };
}

export function getSecondaryActionStyle(theme: DisplayTheme): CSSProperties {
  return {
    background: theme.secondary.soft,
    color: theme.primary.base,
  };
}
